import { Route, Routes } from 'react-router-dom'
import GradeSectionsPage from './Page'
import { useSession } from 'components/Providers'
import NoAccess from 'components/NoAccess';

export default function GradeSections() {
    const { permissions } = useSession();
    if (!permissions['setting.section']) return <NoAccess />

  return (
    <Routes>
      <Route path="/" element={<GradeSectionsPage />} />
      <Route path="/:id" element={<GradeSectionsPage />} />
    </Routes>
  )
}
